import * as tslib_1 from "tslib";
import AttachToolbarButton, { getAttachmentCommandItems } from './AttachToolbarButton';
import ComposeToolbar from './ComposeToolbar';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import createAttachmentHandler from '../utils/createAttachmentHandler';
import focusToEditor from '../utils/focusToEditor';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { IconType } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { lazyInitializeAttachmentFilePicker } from 'owa-attachment-filepicker';
import { Ribbon } from 'owa-editor-ribbonplugin';
import { isGroupTableSelected } from 'owa-group-common';
import { keydownHandler } from 'owa-hotkeys';
import { addInitialAction } from 'owa-initial-actions';
import clickAttachButton from 'owa-mail-compose-store/lib/actions/clickAttachButton';
import discardCompose from 'owa-mail-compose-store/lib/actions/discardCompose';
import setImportance from 'owa-mail-compose-store/lib/actions/setImportance';
import setIsDirty from 'owa-mail-compose-store/lib/actions/setIsDirty';
import toggleFrom from 'owa-mail-compose-store/lib/actions/toggleFrom';
import toggleRibbon from 'owa-mail-compose-store/lib/actions/toggleRibbon';
import trySaveMessage from 'owa-mail-compose-store/lib/actions/trySaveMessage';
import trySendMessage from 'owa-mail-compose-store/lib/actions/trySendMessage';
import protectMessage from 'owa-mail-compose-store/lib/actions/protectMessage';
import { getStore } from 'owa-mail-compose-store/lib/store/composeStore';
import updateDockingHeight from 'owa-mail-compose-store/lib/plugins/docking/actions/updateDockingHeight';
import shouldDisableEncryptionButton from 'owa-mail-compose-store/lib/utils/shouldDisableEncryptionButton';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';
import { getCommands } from 'owa-mail-hotkeys';
import commonStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-mail-strings';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';
import * as React from 'react';
import { getComposeStaticActions, getComposeActionDisplayName, getComposeActionIconName, populateCommandBarWithAddins, logUserAction, } from 'owa-surface-actions';
import { AttachmentLocalComputerFilePicker, FilePickerAction, FileSelectionFilter, } from 'owa-attachment-filepicker-view';
import { getBottomDockingHeight, getTopDockingHeight, } from 'owa-mail-compose-store/lib/plugins/docking/utils/getDockingHeight';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import switchBodytype from 'owa-mail-compose-store/lib/actions/switchBodytype';
import { ENCRYPT_GUID, ENCRYPT_DNF_GUID, } from 'owa-mail-compose-store/lib/store/schema/EncryptionGUID';
var styles = require('./ComposeBottom.scss');
var classNames = require('classnames/bind').bind(styles);
var ComposeBottom = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeBottom, _super);
    function ComposeBottom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.commandBarDividerKey = 0;
        _this.onSend = function () {
            trySendMessage(_this.props.viewState);
        };
        _this.onDiscard = function () {
            discardCompose(_this.props.viewState);
        };
        _this.createAttachmentHandler = function (files, shouldShare, isInline) {
            if (shouldShare === void 0) { shouldShare = false; }
            if (isInline === void 0) { isInline = false; }
            var viewState = _this.props.viewState;
            var inlineImagePlugin = _this.props.plugins && _this.props.plugins.inlineImagePlugin;
            createAttachmentHandler(files, inlineImagePlugin, viewState, shouldShare, isInline);
        };
        _this.onToggleRibbon = function (event, item) {
            var viewState = _this.props.viewState;
            toggleRibbon(viewState);
            _this.logCSAUserAction('ToggleRibbon', item, viewState.isRibbonShown ? 'On' : 'Off');
            var docking = viewState.docking, isInlineCompose = viewState.isInlineCompose, isRibbonShown = viewState.isRibbonShown;
            updateDockingHeight(docking, getTopDockingHeight(isInlineCompose), getBottomDockingHeight(isRibbonShown, isInlineCompose));
            focusToEditor(_this.props.viewState);
        };
        _this.onToggleEmojiPicker = function (event, item) {
            var emojiPlugin = _this.props.plugins.emojiPlugin;
            var emojiViewState = _this.props.viewState.emoji;
            var dataPointSuffix = 'Close';
            if (emojiPlugin.isImported() &&
                emojiViewState.expressionPickerViewState &&
                emojiViewState.expressionPickerViewState.isOpen) {
                emojiPlugin.getPlugin().then(function (plugin) { return plugin.closePicker(); });
            }
            else {
                emojiPlugin.addOnImportedCallback(function (plugin) { return plugin.openPicker(); });
                emojiPlugin.getPlugin();
                dataPointSuffix = 'Open';
            }
            _this.logCSAUserAction('AddEmoji', item, dataPointSuffix);
        };
        _this.onToggleAccChecker = function (event, item) {
            var accCheckerPlugin = _this.props.plugins.accCheckerPlugin;
            var accCheckerViewState = _this.props.viewState.accChecker;
            var dataPointSuffix = 'Close';
            if (accCheckerPlugin.isImported() && accCheckerViewState.isOpen) {
                accCheckerPlugin.getPlugin().then(function (plugin) { return plugin.closeChecker(); });
            }
            else {
                accCheckerPlugin.addOnImportedCallback(function (plugin) { return plugin.openChecker(); });
                accCheckerPlugin.getPlugin();
                dataPointSuffix = 'Open';
            }
            _this.logCSAUserAction('AccChecker', item, dataPointSuffix);
        };
        _this.onOpenInlineFilePicker = function (event, item) {
            _this.logCSAUserAction('AddInlineImage', item);
            if (!_this.props.viewState.itemId) {
                trySaveMessage(_this.props.viewState);
            }
            _this.attachmentInlineFilePicker.getInnerComponent().click();
        };
        _this.onInsertSignature = function (event, item) {
            _this.logCSAUserAction('InsertSignature', item);
            var viewState = _this.props.viewState;
            var bodyType = viewState.bodyType;
            _this.props.plugins.contentOperationPlugin.insertSignature(bodyType);
            setIsDirty(viewState);
        };
        _this.onSetImportance = function (importance, item) {
            _this.logCSAUserAction('SetImportance', item, importance);
            setImportance(_this.props.viewState, importance);
            focusToEditor(_this.props.viewState);
        };
        _this.onSwitchBodyType = function (event, item) {
            var suffix = _this.props.viewState.bodyType == 'HTML' ? 'Plain' : 'HTML'; // Reversed to log the type being set.
            _this.logCSAUserAction('SwitchBodyType', item, suffix);
            switchBodytype(_this.props.viewState);
        };
        return _this;
    }
    ComposeBottom.prototype.createCommandBarItems = function () {
        var _this = this;
        var surfaceItems = [];
        var overflowItems = [];
        var staticActions = getComposeStaticActions();
        var surfaceActionsOptions = getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions);
        staticActions.forEach(function (action) {
            var commandBarItem = _this.tryCreateStaticActionCommandBarItem(action);
            if (commandBarItem) {
                // If we were able to create a command bar item, check if the user has it in their surface actions.
                if (surfaceActionsOptions.composeSurfaceActions.indexOf(action.key) >= 0) {
                    // If they do, push it to the surface.
                    commandBarItem.isPinned = true;
                    if (commandBarItem.subMenuProps) {
                        commandBarItem.subMenuProps.items.forEach(function (subItem) {
                            subItem.isPinned = true;
                        });
                    }
                    surfaceItems.push(commandBarItem);
                }
                else {
                    // If they don't, push it to the overflow and override any custom rendering.
                    commandBarItem.onRender = null;
                    commandBarItem.renderedInOverflow = true;
                    if (commandBarItem.subMenuProps) {
                        commandBarItem.subMenuProps.items.forEach(function (subItem) {
                            subItem.renderedInOverflow = true;
                        });
                    }
                    overflowItems.push(commandBarItem);
                }
            }
        });
        // Push add-ins to the command bar if the add-ins flight is on and we're not in groups.
        if (isMailFeatureEnabled('rp-addins') &&
            !(isMailFeatureEnabled('grp') && isGroupTableSelected())) {
            populateCommandBarWithAddins(ExtensibilityModeEnum.MessageCompose, this.props.viewState.composeId, surfaceActionsOptions.composeSurfaceAddins, surfaceItems, overflowItems, false /* isEndAligned */, this.commandBarDividerKey, styles.addinCommandBarItem /* className */);
        }
        return { items: surfaceItems, overflowItems: overflowItems };
    };
    ComposeBottom.prototype.tryCreateStaticActionCommandBarItem = function (action) {
        var _this = this;
        if (action.hideInGroup && isGroupTableSelected()) {
            return null;
        }
        var actionKey = action.key;
        var displayName = getComposeActionDisplayName(actionKey);
        var _a = getComposeActionIconName(actionKey), fallbackIconName = _a.fallbackIconName, isImage = _a.isImage;
        var isDisabled = false;
        var canCheck = false;
        var isChecked = false;
        var clickHandler;
        var subMenuProps;
        var customClassName;
        var customRender;
        var isPlainText = this.props.viewState.bodyType != 'HTML';
        var storeState = getStore();
        switch (actionKey) {
            case 'AddAttachment':
                if (isAttachmentFeatureEnabled('doc-attachment-dualEntryPointNewControl')) {
                    subMenuProps = {
                        items: getAttachmentCommandItems(function () { return _this.attachmentLocalComputerFilePicker; }, this.props.plugins && this.props.plugins.inlineImagePlugin, this.props.viewState),
                    };
                    customClassName = styles.attachmentCommandBarButtonWithSubMenu;
                }
                else {
                    clickHandler = this.attachmentToolbarItem.onClick;
                    if (this.attachmentToolbarItem.customRender) {
                        customRender = function () {
                            return _this.attachmentToolbarItem.customRender(classNames(styles.attachmentCommandBarButton, styles.commandBarButton));
                        };
                    }
                }
                break;
            case 'AddInlineImage':
                clickHandler = this.onOpenInlineFilePicker;
                isDisabled = isPlainText;
                break;
            case 'AddEmoji':
                clickHandler = this.onToggleEmojiPicker;
                isDisabled = isPlainText;
                canCheck = true;
                isChecked =
                    this.props.viewState.emoji.expressionPickerViewState &&
                        this.props.viewState.emoji.expressionPickerViewState.isOpen;
                break;
            case 'ToggleRibbon':
                isDisabled = isPlainText;
                displayName = this.props.viewState.isRibbonShown
                    ? strings.formattingOptionsTooltipHide
                    : strings.formattingOptionsTooltip; // Override default string based on actual state
                clickHandler = this.onToggleRibbon;
                canCheck = true;
                isChecked = this.props.viewState.isRibbonShown;
                break;
            case 'ProtectMessage':
                subMenuProps = {
                    items: [
                        {
                            name: strings.encryptMenuText,
                            key: 'Encrypt',
                            onClick: function () {
                                protectMessage(_this.props.viewState, storeState.complianceConfigurations, ENCRYPT_GUID);
                            },
                            disabled: shouldDisableEncryptionButton(this.props.viewState, ENCRYPT_GUID),
                        },
                        {
                            name: strings.encryptDisableForwardingMenuText,
                            key: 'EncryptDNF',
                            onClick: function () {
                                protectMessage(_this.props.viewState, storeState.complianceConfigurations, ENCRYPT_DNF_GUID);
                            },
                            disabled: shouldDisableEncryptionButton(this.props.viewState, ENCRYPT_DNF_GUID),
                        },
                    ],
                };
                isDisabled = shouldDisableEncryptionButton(this.props.viewState);
                customClassName = styles.commandBarButtonWithSubMenu;
                break;
            case 'SaveDraft':
                clickHandler = function (event, item) {
                    _this.logCSAUserAction(actionKey, item);
                    trySaveMessage(_this.props.viewState);
                    focusToEditor(_this.props.viewState);
                };
                break;
            case 'InsertSignature':
                clickHandler = this.onInsertSignature;
                break;
            case 'ShowFrom':
                var isFromShown_1 = this.props.viewState.fromViewState.isFromShown;
                displayName = !isFromShown_1 ? strings.showFrom : strings.hideFrom; // Override default string based on actual state
                clickHandler = function (event, item) {
                    _this.logCSAUserAction(actionKey, item, isFromShown_1 ? 'Hide' : 'Show');
                    toggleFrom(_this.props.viewState);
                    focusToEditor(_this.props.viewState);
                };
                break;
            case 'SetImportance':
                subMenuProps = {
                    items: [
                        {
                            name: strings.highImportanceMenuText,
                            key: 'High',
                            onClick: function (event, item) {
                                _this.onSetImportance('High', item);
                            },
                        },
                        {
                            name: strings.normalImportanceMenuText,
                            key: 'Normal',
                            onClick: function (event, item) {
                                _this.onSetImportance('Normal', item);
                            },
                        },
                        {
                            name: strings.lowImportanceMenuText,
                            key: 'Low',
                            onClick: function (event, item) {
                                _this.onSetImportance('Low', item);
                            },
                        },
                    ],
                };
                customClassName = styles.commandBarButtonWithSubMenu;
                break;
            case 'SwitchBodyType':
                if (!this.props.viewState.isInlineCompose) {
                    displayName = isPlainText
                        ? strings.switchToHTMLMenuItem
                        : strings.switchToPlainTextMenuItem;
                    clickHandler = this.onSwitchBodyType;
                }
                break;
            case 'AccChecker':
                isDisabled = isPlainText;
                canCheck = true;
                isChecked = this.props.viewState.accChecker.isOpen;
                clickHandler = this.onToggleAccChecker;
                break;
        }
        if (clickHandler || subMenuProps) {
            var iconType = isImage ? IconType.image : IconType.default;
            var imageProps = isImage
                ? { shouldFadeIn: false, src: fallbackIconName, className: styles.commandBarImage }
                : null;
            var iconClassName = classNames(styles.commandBarIcon, {
                isImage: isImage,
                isIE: isBrowserIE(),
            });
            return {
                key: actionKey,
                name: displayName,
                iconProps: {
                    iconName: fallbackIconName,
                    iconType: iconType,
                    imageProps: imageProps,
                    className: iconClassName,
                },
                disabled: isDisabled,
                canCheck: canCheck,
                checked: isChecked,
                onClick: clickHandler,
                subMenuProps: subMenuProps,
                className: customClassName,
                onRender: customRender,
                iconOnly: true,
                ariaLabel: displayName,
            };
        }
        else {
            return null;
        }
    };
    ComposeBottom.prototype.componentDidMount = function () {
        addInitialAction(this.props.initialActions, function () {
            lazyInitializeAttachmentFilePicker
                .import()
                .then(function (initializeAttachmentFilePicker) { return initializeAttachmentFilePicker(); });
        });
    };
    ComposeBottom.prototype.render = function () {
        var _this = this;
        var _a = this.props, viewState = _a.viewState, plugins = _a.plugins, isHidden = _a.isHidden;
        var isInlineCompose = viewState.isInlineCompose, isRibbonShown = viewState.isRibbonShown, ribbon = viewState.ribbon, useStickyDocking = viewState.docking.useStickyDocking;
        var handler = attachmentMultiMenuEntry.computer.getCreateAttachmentHandler(viewState.attachmentWell, function (files, shouldShare, isInline) {
            return plugins &&
                createAttachmentHandler(files, plugins.inlineImagePlugin, viewState, shouldShare, isInline);
        });
        return (React.createElement("div", { className: classNames({
                cardUI: isReadingPaneCardUIEnabled(),
                isInlineCompose: isInlineCompose,
                sticky: useStickyDocking,
                isHidden: !useStickyDocking && isHidden,
            }) },
            isRibbonShown &&
                plugins && (React.createElement(Ribbon, { className: styles.ribbonRow, ribbonPlugin: plugins.ribbonPlugin, viewState: ribbon, skipInitialResize: true })),
            this.renderBottomBar(),
            useStickyDocking &&
                !isInlineCompose && React.createElement("div", { className: styles.stickyBottomFiller }),
            React.createElement(AttachmentLocalComputerFilePicker, { ref: function (ref) { return (_this.attachmentInlineFilePicker = ref); }, fileSelectionFilter: FileSelectionFilter.Images, action: FilePickerAction.Insert, createAttachmentHandler: this.createAttachmentHandler }),
            isAttachmentFeatureEnabled('doc-attachment-dualEntryPointNewControl') && (React.createElement(AttachmentLocalComputerFilePicker, { ref: function (ref) { return (_this.attachmentLocalComputerFilePicker = ref); }, fileSelectionFilter: FileSelectionFilter.None, action: FilePickerAction.Attach, createAttachmentHandler: handler }))));
    };
    ComposeBottom.prototype.resize = function () {
        if (this.toolbar) {
            this.toolbar.resize();
        }
    };
    ComposeBottom.prototype.renderBottomBar = function () {
        var _this = this;
        var viewState = this.props.viewState;
        var asyncSendState = viewState.asyncSendState, isInlineCompose = viewState.isInlineCompose, isSending = viewState.isSending, isSavingSpinnerShown = viewState.isSavingSpinnerShown;
        if (isSending) {
            if (asyncSendState == 3 /* Timeout */) {
                // For async send timeout, we are in floating compose now, so show the timeout info
                return (React.createElement("div", { className: styles.buttonBar }, commonStrings.errorAsyncSendTimeout));
            }
            else {
                // Sync send, or async send before client side validation finished
                return isInlineCompose ? (
                // For inline compose, we don't have commanding bar, so show spinner here
                React.createElement("div", { className: styles.buttonBar },
                    React.createElement(Spinner, { className: styles.composeSpinner }),
                    React.createElement("div", { className: styles.composeSpinnerText }, strings.sending))) : (
                // Full compose, spinner is showing in commanding bar, just show the empty DIV to provide bottom border;
                React.createElement("div", { className: styles.buttonBar }));
            }
        }
        else if (isSavingSpinnerShown) {
            // For saving, render a spinner with saving text
            return (React.createElement("div", { className: styles.buttonBar },
                React.createElement(Spinner, { className: styles.composeSpinner }),
                React.createElement("div", { className: styles.composeSpinnerText }, strings.saving)));
        }
        else if (asyncSendState == 4 /* Sent */) {
            return (React.createElement("div", { className: styles.buttonBar },
                React.createElement(Icon, { iconName: "CheckMark" /* CheckMark */, className: styles.toastIcon }),
                strings.messageIsSentInfo));
        }
        else {
            // Normal case, show Send/Discard button and toolbar
            var commandBarData = this.createCommandBarItems();
            return (React.createElement(ComposeToolbar, { ref: function (ref) { return (_this.toolbar = ref); }, viewState: viewState, composeId: this.props.viewState.composeId, onSend: this.onSend, onDiscard: this.onDiscard, commandBarData: commandBarData }));
        }
    };
    ComposeBottom.prototype.sendMessage = function () {
        trySendMessage(this.props.viewState);
    };
    ComposeBottom.prototype.saveDraft = function () {
        trySaveMessage(this.props.viewState);
    };
    ComposeBottom.prototype.discardDraft = function () {
        discardCompose(this.props.viewState);
    };
    Object.defineProperty(ComposeBottom.prototype, "attachmentToolbarItem", {
        get: function () {
            var _this = this;
            var attachmentToolbarItem = {
                name: strings.attachTooltip,
                key: 'addAttachment',
                imageUrl: getComposeActionIconName('AddAttachment').fallbackIconName,
                onClick: function () {
                    clickAttachButton(false /*isInline*/, _this.createAttachmentHandler, _this.props.viewState);
                },
            };
            if (isAttachmentFeatureEnabled('doc-attachment-dualEntryPoint')) {
                attachmentToolbarItem.customRender = function (className) {
                    return (React.createElement(AttachToolbarButton, { key: "attachToolbarButton", className: className, viewState: _this.props.viewState, inlineImagePlugin: _this.props.plugins && _this.props.plugins.inlineImagePlugin, menuItem: attachmentToolbarItem }));
                };
            }
            return attachmentToolbarItem;
        },
        enumerable: true,
        configurable: true
    });
    ComposeBottom.prototype.logCSAUserAction = function (action, item, suffix) {
        if (suffix === void 0) { suffix = ''; }
        logUserAction(true /* isCompose */, "" + action + suffix, item);
    };
    tslib_1.__decorate([
        keydownHandler(getCommands().sendMail)
    ], ComposeBottom.prototype, "sendMessage", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().saveDraft)
    ], ComposeBottom.prototype, "saveDraft", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().discardDraft, true /*stopPropagation*/, true /*preventDefault*/, true /*allowHotkeyOnTextFields*/)
    ], ComposeBottom.prototype, "discardDraft", null);
    tslib_1.__decorate([
        computed
    ], ComposeBottom.prototype, "attachmentToolbarItem", null);
    ComposeBottom = tslib_1.__decorate([
        observer
    ], ComposeBottom);
    return ComposeBottom;
}(React.Component));
export default ComposeBottom;
//# sourceMappingURL=ComposeBottom.js.map